import {attributeBasedProjection} from '../projection-function-shared/attributeBasedProjection';

// The entity table formatter has the same 'attributes' array as the card formatter, so we can use the same projection function
const entityTableProjectionFn = attributeBasedProjection;

export default entityTableProjectionFn;
